import {
	Pipe,
	PipeTransform
} from '@angular/core';

@Pipe( { name: 'toEmptyString' } )
export class ToEmptyStringPipe implements PipeTransform {

	private convertToString( value: any ) {
		if ( value === undefined || value === null || value === 'undefined' || value === 'null' ) {
			return '';
		} else {
			return value;
		}
	}

	transform( value: any ): any {
		const itemValue: any = this.convertToString( value );

		if ( itemValue instanceof Object ) {
			Object.entries( itemValue ).forEach(
				( [ key, val ] ) => {
					itemValue[ key ] = this.convertToString( val );
				}
			);
		}

		return itemValue;
	}
}
